import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { UserBidsMoleculeReatom } from "./user-bids-molecule.reatom"

export const useUserBidsQueryResultReatom = () => {
  const { queryParamsAtom } = useMolecule(UserBidsMoleculeReatom)
  const queryParams = queryParamsAtom()

  return useSuspenseInfiniteQuery(queryParams)
}
